module.exports = __webpack_public_path__ + "static/scale-model-of-venice-beach-drum-circle-in-los-angeles-california-24bf2d8dad1ab6708f04c9f55330020f.png";